<template>
    <v-container fluid>
        <v-toolbar color="primary" dense>
            <v-spacer></v-spacer>
            <v-toolbar-title class="white--text">Reports</v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-form ref="form" lazy-validation>
            <v-container class="pa-10" fluid>
                <v-row>
                    <v-col>
                        <v-text-field
                            label="Start Date"
                            type="tel"
                            id="StartDate"
                            :value="startDate"
                            :placeholder="$store.state.placeholder"
                            v-mask="$store.state.mask"
                            :rules="$store.state.dateRules"
                        ></v-text-field>
                    </v-col>
                    <v-col>
                        <v-text-field
                            label="End Date"
                            type="tel"
                            id="EndDate"
                            :value="endDate"
                            :placeholder="$store.state.placeholder"
                            v-mask="$store.state.mask"
                            :rules="$store.state.dateRules"
                        ></v-text-field>
                    </v-col>
                    <v-col>
                        <v-combobox
                            v-model="customer"
                            :items="customers"
                            :item-text="'Name'"
                            :item-value="'id'"
                            auto-select-first
                            label="Customer"
                        ></v-combobox>
                    </v-col>
                    <v-col>
                        <v-combobox
                            v-model="station"
                            :items="stations"
                            :item-text="'Name'"
                            :item-value="'id'"
                            auto-select-first
                            label="Stations"
                        ></v-combobox>
                    </v-col>
                    <v-col>
                        <v-combobox
                            v-model="truck"
                            :items="trucks"
                            :item-text="'Truck'"
                            :item-value="'TruckID'"
                            auto-select-first
                            label="Trucks"
                        ></v-combobox>
                    </v-col>
                    <v-col>
                        <v-combobox
                            v-model="region"
                            :items="regions"
                            :item-text="'PrincipalRegion'"
                            :item-value="'PrincipalRegionID'"
                            label="Select Region"
                            auto-select-first
                        ></v-combobox>
                    </v-col>
                </v-row>
                <v-row class="justify-center">
                    <v-col cols="12">
                        <v-row class="justify-center">
                            <v-row class="my-4">
                                <div
                                    style="width: 100%"
                                    class="mx-auto ml-5 mb-5"
                                >
                                    <div
                                        class="d-flex justify-space-around mb-6"
                                    >
                                        <v-btn
                                            v-for="report in reports"
                                            :key="report.key"
                                            style="width: 200px"
                                            color="info"
                                            @click="
                                                validate(
                                                    report.url,
                                                    report.name,
                                                    report.missing,
                                                    report.type
                                                )
                                            "
                                            dense
                                            >{{ report.name }}</v-btn
                                        >
                                    </div>
                                </div>
                                <div
                                    style="border: #ddd 1px solid; width: 100%"
                                    class="mx-auto ml-5 mb-5"
                                >
                                    <h3 class="text-center mb-4">Orders</h3>
                                    <div
                                        class="d-flex justify-space-around mb-6"
                                    >
                                        <v-btn
                                            v-for="order in orders"
                                            :key="order.key"
                                            style="width: 200px"
                                            color="info"
                                            @click="
                                                validate(
                                                    order.url,
                                                    order.name,
                                                    0
                                                )
                                            "
                                            dense
                                            >{{ order.name }}</v-btn
                                        >
                                    </div>
                                </div>
                                <div
                                    style="border: #ddd 1px solid; width: 100%"
                                    class="ml-5 mb-5"
                                >
                                    <h3 class="text-center mb-4">Demurrage</h3>
                                    <div
                                        class="d-flex justify-space-around mb-6"
                                    >
                                        <v-btn
                                            v-for="demurrage in demurrages"
                                            :key="demurrage.key"
                                            style="width: 200px"
                                            color="info"
                                            @click="
                                                validate(
                                                    demurrage.url,
                                                    demurrage.name,
                                                    0
                                                )
                                            "
                                            dense
                                            >{{ demurrage.name }}</v-btn
                                        >
                                    </div>
                                </div>
                                <div
                                    style="border: #ddd 1px solid; width: 100%"
                                    class="ml-5 mb-5"
                                >
                                    <h3 class="text-center mb-4">Tracking</h3>
                                    <div
                                        class="d-flex justify-space-around mb-6"
                                    >
                                        <v-btn
                                            v-for="track in tracking"
                                            :key="track.key"
                                            style="width: 200px"
                                            color="info"
                                            @click="
                                                validate(
                                                    track.url,
                                                    track.name,
                                                    0
                                                )
                                            "
                                            dense
                                            >{{ track.name }}</v-btn
                                        >
                                    </div>
                                </div>
                                <div
                                    style="border: #ddd 1px solid; width: 100%"
                                    class="mx-auto ml-5 mb-5"
                                >
                                    <h3 class="text-center mb-4">Eleos</h3>
                                    <div
                                        class="d-flex justify-space-around mb-6"
                                    >
                                        <v-btn
                                            v-for="e in eleos"
                                            :key="e.key"
                                            style="width: 250px"
                                            color="info"
                                            @click="validate(e.url, e.name, 0)"
                                            dense
                                            >{{ e.name }}</v-btn
                                        >
                                    </div>
                                </div>
                                <div
                                    style="border: #ddd 1px solid; width: 100%"
                                    class="mx-auto ml-5 mb-5"
                                >
                                    <h3 class="text-center mb-4">
                                        Dispatch Score Card
                                    </h3>
                                    <div
                                        class="d-flex justify-space-around mb-6"
                                    >
                                        <v-btn
                                            v-for="e in dispatchScore"
                                            :key="e.key"
                                            style="width: 250px"
                                            color="info"
                                            @click="openDS(e)"
                                            dense
                                            >{{ e.name }}</v-btn
                                        >
					                    <v-btn
                                            style="width: 250px"
                                            color="info"
                                            @click="report('report-times/loads','RunOut Report',0)"
                                            dense
                                            >RunOut Report</v-btn
                                        >
                                    </div>
                                </div>
                            </v-row>
                        </v-row>
                    </v-col>
                </v-row>
            </v-container>
        </v-form>
        <dispatch_score
            v-if="$store.state.scoreCard.allDialog"
            :StartDate="startDate"
            :EndDate="endDate"
        ></dispatch_score>
    </v-container>
</template>

<script>
import axios from 'axios';
import { mask } from 'vue-the-mask';
import dispatch_score from './../Modals/Reports/DispatchScoreCard/DispatchScore.vue';
export default {
    name: 'Reports',
    components: {
        dispatch_score
    },
    directives: { mask },
    data: function() {
        return {
            startDate: '',
            endDate: '',
            customer: '',
            invoiceId: '',
            station: [],
            stations: null,
            customers: null,
            trucks: null,
            regions: [],
            region: [],
            truck: '',
            reports: [
                {
                    name: 'Missing Paperwork',
                    url: '/shift-detail/ppwExcel',
                    missing: true
                },
                {
                    name: 'Drivers on Shift',
                    url: '/shift-detail/drivers-on-shift',
                    missing: false
                },
                {
                    name: 'Unfinalized Shifts',
                    url: '/shift-detail/unfinalized-shifts',
                    missing: false
                },
                {
                    name: 'Unfinalized Report',
                    url: '/shifts-unifinalized/report',
                    missing: false
                },
                {
                    name: 'Transaction InvId',
                    url: '/transaction/customer/report',
                    type: true,
                    missing: false
                },
                {
                    name: 'Transaction Pay',
                    url: '/transaction/customer/report',
                    type: false,
                    missing: false
                }
            ],
            orders: [
                {
                    name: 'Orders To Transact',
                    url: '/order/ordersToTransact'
                },
                {
                    name: 'Uninvoiced Orders',
                    url: '/order/uninvoiced-orders'
                },
                {
                    name: 'Unpaid Orders',
                    url: '/order/unpaid-orders/'
                },
                {
                    name: 'Liters by Truck',
                    url: '/order/litres-by-trucks'
                }
            ],
            demurrages: [
                {
                    name: 'Uninvoiced Demurrage',
                    url: '/order/uninvoiced-demurrage'
                },
                {
                    name: 'Unpaid Demurrage',
                    url: '/order/unpaid-demurrage'
                },
                {
                    name: 'Paid Demurrage',
                    url: '/order/paid-demurrage'
                }
            ],
            tracking: [
                {
                    name: 'Load Tracking',
                    url: '/order/load-tracking'
                },
                {
                    name: 'Station Details',
                    url: 'order/station/details'
                },
                {
                    name: 'Finalized Shifts',
                    url: '/shift-detail/finalized-shifts'
                },
                {
                    name: 'Trucks Inactive',
                    url: 'truck-idle/report'
                }
            ],
            eleos: [
                {
                    name: 'BOL Data By Product',
                    url: '/eleos-report/data-bol-by-product'
                },
                {
                    name: 'Forced Completion',
                    url: '/eleos-report/forced-completion'
                },
                /*{
                    name: 'Drivers Using ASR App',
                    url: '/eleos-report/drivers-using-asr-app',
                },*/
                {
                    name: 'Eleos-Tracking Time Diff',
                    url: '/eleos-report/time-diff'
                },
                {
                    name: 'GPSHrs VS PayHrs',
                    url: '/payroll/gpshrs/vs/payhrs'
                },
                {
                    name: 'OrderHrs VS PayHrs',
                    url: '/payroll/ords/vs/payhrs'
                }
            ],
            dispatchScore: [
                {
                    name: 'Dispatch Score',
                    report: 'dispatch/score/all'
                },
            ],
            dateRules: [
                v => !!v || 'This date is required',
                v =>
                    (parseInt(v[5] + v[6]) <= 12 &&
                        parseInt(v[5] + v[6]) > 0) ||
                    'Date Incorrect',
                v =>
                    (parseInt(v[8] + v[9]) <= 31 &&
                        parseInt(v[8] + v[9]) > 0) ||
                    'Date Incorrect'
            ]
        };
    },

    mounted() {
        this.loadCustomers();
        this.loadStations();
        this.loadTrucks();
        this.loadRegions();
    },

    methods: {
        openDS: function(type) {
            console.log(type);
            if (type.name == 'Dispatch Score') {
                this.$store.state.scoreCard.allDialog = true;
            }
        },
        loadRegions: function() {
            this.$store.state.isLoading = true;
            axios
                .get('regions')
                .then(response => {
                    this.regions = response.data;
                    this.regions.push({
                        PrincipalRegionID: 5,
                        PrincipalRegion: 'All'
                    });
                    this.region = this.regions[3];
                })
                .catch(function(error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        loadTrucks: function() {
            this.$store.state.isLoading = true;
            axios
                .get('truck/active')
                .then(response => {
                    console.log(response.data);
                    this.trucks = response.data;
                    this.$store.state.isLoading = false;
                })
                .catch(error => {
                    this.$store.state.isLoading = false;
                    console.log(error);
                });
        },
        loadCustomers: function() {
            this.$store.state.isLoading = true;
            axios
                .get('customer/active')
                .then(response => {
                    console.log(response.data.data);
                    this.customers = response.data.data;
                })
                .catch(function(error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },

        validate(url, name, missing, type) {
            if (this.$refs.form.validate() == false) {
                this.$refs.form.validate();
            } else {
                this.report(url, name, missing, type);
            }
        },
        loadStations: function() {
            this.$store.state.isLoading = true;
            axios
                .get('station/active')
                .then(response => {
                    this.stations = response.data.data;
                    console.log(this.stations);
                })
                .catch(function(error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        report: function(url, name, missing, type) {
            var parms = {
                StartDate: this.$store.state.getMsk('StartDate'),
                EndDate: this.$store.state.getMsk('EndDate'),
                InvID: this.invoiceId,
                Customer: this.customer != null ? this.customer.id : null,
                Export: true,
                Station: this.station.id,
                Truck: this.truck != null ? this.truck.TruckID : null,
                Missing: missing,
                Type:type,
                Region: this.region.PrincipalRegionID,
		        Export: 1
            };

            console.log(parms);
            this.$store.state.isLoading = true;
            axios
                .post(url, parms, {
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    var fileName = name + '.xlsx';
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', fileName);
                    console.log(this.startDate);
                    document.body.appendChild(link);
                    link.click();
                    this.$store.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    this.$store.state.isLoading = false;
                });
        }
    }
};
</script>
